function selectFremiumProfileStatus(profileData) {
	const { clientCount, premium } = profileData;

	return { clientCount, premium };
}

export default selectFremiumProfileStatus;
